import {POSTER_FLOOR_ACTIVE_LABEL_ID} from '../constants/other'

export default {
    computed: {
        startUnitPos() {
            return this.mapViewer.viewApi[`get_unit_screen_pos`](this.startUnit);
        },
        finishUnitPos() {
            return this.mapViewer.viewApi[`get_unit_screen_pos`](this.finishUnit);
        },
        floorLabelPositionName() {
            return this.getMapConfigProp('map_views.poster.floor_label_position', 'left');
        }
    },
    methods: {
        getActiveFloorElement() {
            return document.getElementById(POSTER_FLOOR_ACTIVE_LABEL_ID);
        },
        getActiveFloorElementWidth() {
            return document.getElementById(POSTER_FLOOR_ACTIVE_LABEL_ID)?.getBoundingClientRect().width;
        },
        getActiveFloorElementHalfHeight() {
            return document.getElementById(POSTER_FLOOR_ACTIVE_LABEL_ID)?.getBoundingClientRect().height/2;
        },
        getHereIcon() {
            return this.getActiveFloorElement()?.getElementsByClassName('a-p-floor-label__here')[0].getBoundingClientRect();
        },
        getHereIconHalfWidth() {
            return this.getHereIcon()?.width/2
        },
        getHereIconHalfHeight() {
            return this.getHereIcon()?.height/2
        },
        calculateAngle(y0, y, x0, x) {
            return Math.atan2(y0 - y, x0 - x) * 180 / Math.PI;
        },
        calculateLineDistance(x, y, x0, y0){
            return Math.sqrt((x -= x0) * x + (y -= y0) * y);
        },
        getStartPosX() {
            if( !!this.customStartPositons && this.floorLabelPositionName == 'left') {
                return this.getHereIconHalfWidth() 
                    ? this.getActiveFloorElementWidth() - this.getHereIconHalfWidth() 
                    : this.startUnitPos.x
            } else if( !!this.customStartPositons && this.floorLabelPositionName == 'right') {
                return this.getMapWidth() 
                    ? this.getMapWidth() - this.getActiveFloorElementWidth() + this.getHereIconHalfWidth()
                    : this.startUnitPos.x
            }
            return this.startUnitPos.x
        },
        getStartPosY() {
            if( !!this.customStartPositons && this.floorLabelPositionName == 'top') {
                return this.getActiveFloorElementHalfHeight() ? this.getActiveFloorElementHalfHeight() : startUnitPos.y
            } else if( !!this.customStartPositons && this.floorLabelPositionName == 'bottom') {
                return this.getMapHeight() ? this.getMapHeight() - this.getActiveFloorElementHalfHeight(): startUnitPos.y
            }
            return this.startUnitPos.y
        },
        getAngle() {
            if (this.startUnitPos && this.finishUnitPos) {
                let lineAngle = this.calculateAngle(this.finishUnitPos.y, this.getStartPosY(), this.finishUnitPos.x, this.getStartPosX());

                if( !!this.customStartPositons && this.floorLabelPositionName == 'top') {
                    lineAngle = this.calculateAngle(this.finishUnitPos.y, this.getStartPosY(), this.finishUnitPos.x, this.getStartPosX() - this.getHereIconHalfWidth())
                } else if( !!this.customStartPositons && this.floorLabelPositionName == 'bottom') {
                    lineAngle = this.calculateAngle(this.finishUnitPos.y, this.getStartPosY(), this.finishUnitPos.x, this.getStartPosX() - this.getHereIconHalfWidth())
                } else if( !!this.customStartPositons && this.floorLabelPositionName == 'left') {
                    lineAngle = this.calculateAngle(this.finishUnitPos.y, this.getStartPosY(), this.finishUnitPos.x, this.getStartPosX())
                } else if( !!this.customStartPositons && this.floorLabelPositionName == 'right') {
                    lineAngle = this.calculateAngle(this.finishUnitPos.y, this.getStartPosY(), this.finishUnitPos.x, this.getStartPosX())
                }

                return lineAngle
            } else {
                console.error(`getAngle: can't get position for unit`)
                return 0
            }
        },
        getLineWidth() {
            if (this.startUnitPos && this.finishUnitPos) {
                let lineWidth = this.calculateLineDistance(this.getStartPosX(), this.getStartPosY(), this.finishUnitPos.x, this.finishUnitPos.y);

                if( !!this.customStartPositons && (this.floorLabelPositionName == 'top' || this.floorLabelPositionName == 'bottom')) {
                    lineWidth = this.calculateLineDistance(this.getStartPosX() - this.getHereIconHalfWidth(), this.getStartPosY(), this.finishUnitPos.x, this.finishUnitPos.y);
                } else if( !!this.customStartPositons && (this.floorLabelPositionName == 'left' || this.floorLabelPositionName == 'right')) {
                    lineWidth = this.calculateLineDistance(this.getStartPosX(), this.getStartPosY(), this.finishUnitPos.x, this.finishUnitPos.y);
                }

                return lineWidth
            } else {
                console.error(`getLineDistance: can't get position for unit`)
                return 0
            }
        },
        getMapPosition() {
            const mapCoordinate = document.getElementById('map_viewer_iframe')?.getBoundingClientRect()
            return mapCoordinate
        },
        getMapWidth() {
            return +this.getMapPosition().width
        },
        getMapHeight() {
            return +this.getMapPosition().height
        }
    }
}